import React, { forwardRef, useImperativeHandle, useEffect, useState } from "react";
import { Pagination, Tag, Input, Radio } from 'antd';
import { Table, Switch } from "components/common";
import { Wrapper,CustomStyles } from "./UserTable.styled";
import { Button } from "components/common";
import { ReloadOutlined } from '@ant-design/icons';
import { useHistory } from "react-router";
import { getUserPermissions } from "utils/text";
import { FiEye } from 'react-icons/fi';
import { Checkbox } from 'antd';



const UsersTable = forwardRef(({ isLoading, roles, data, handleLoginAsUser, updatePagination, pagination, sortHandleChange, handleChangeFilter, location,sortBy }, ref) => {
  const history = useHistory();
  const [offset, setOffset] = useState();
  const [limit, setLimit] = useState();

  const [sortDirection, setSortDirection] = useState("ascend");
  const [reloadClicked, setReloadClicked] = useState(false);

  const [selectedFilters, setSelectedFilters] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filteredLocationSearch, setFilteredLocationSearch] = useState([]);
  const [selectedLocationSearch, setSelectedLocationSearch] = useState([]);
  const [filteredRoleSearch, setFilteredRoleSearch] = useState([]);
  const [selectedRoleSearch, setSelectedRoleSearch] = useState([]);

  // Filter 
  const [statusFilterAction, setStatusFilterAction] = useState(true)


  function onShowSizeChange(current, pageSize) {
    updatePagination(current <= 0 ? 0 : current - 1, pageSize);
  }
  const handleChangePagination = (e) => {
    updatePagination(e <= 0 ? 0 : e - 1, undefined);
    setFilteredData([]);
  }

  const handleOnChange = (name,dir) => {
    sortHandleChange(name,dir);
    
  }

  const handleSortOnChange = (row, col, sorter) => {
    console.log(sorter);
    if(sorter.column) {
      if(sorter.column.dataIndex === 'firstName'){
        sortHandleChange('firstName', !sorter.order || sorter.order === 'ascend' ? 1 : -1);
      }
      if(sorter.column.dataIndex === 'email'){
        sortHandleChange('email', !sorter.order || sorter.order === 'ascend' ? 1 : -1);
      }

    }
  }

  const handleFilterLocation = (value, data) => {
    return (
      data?.locationName?.name.toLowerCase().includes(value.toLowerCase()) ||
      data?.locationName?.state.toLowerCase().includes(value.toLowerCase())
    );
  };

  const handleSortDirectionChange = () => {
    const newSortDirection = sortDirection === "ascend" ? "descend" : "ascend";
    setSortDirection(newSortDirection);
  };

  const handleCheckboxChangeLocation = (id) => {
    if (selectedLocationSearch.includes(id)) {
      const filtered = selectedLocationSearch.filter((e) => e !== id);
      setSelectedLocationSearch(filtered);
    }
    else {
      setSelectedLocationSearch((prev) => ([...prev, id]));
    }
  };
  const handleCheckboxChangeRoles = (id) => {
    if (selectedRoleSearch.includes(id)) {
      const filtered = selectedRoleSearch.filter((e) => e !== id);
      setSelectedRoleSearch(filtered);
    }
    else {
      setSelectedRoleSearch((prev) => ([...prev, id]));
    }
  };

  const handleFilterLocationSearch = (e) => {
    const { value } = e.target;
    if (!value) {
      setFilteredLocationSearch(location);
    }
    else {
      const filteredLocation = location.filter((e) => e.name.toLowerCase().includes(value.toLowerCase()));
      setFilteredLocationSearch(filteredLocation);
    }

  };

  const handleFilterRoleSearch = (e) => {
    const { value } = e.target;
    if (!value) {
      setFilteredRoleSearch(roles);
    }
    else {
      const filteredRole = roles.filter((e) => e.name.toLowerCase().includes(value.toLowerCase()));
      setFilteredRoleSearch(filteredRole);
    }

  };

  const columns = [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_, data) => (
        <div style={CustomStyles.tagContainer}>
          <Tag style={CustomStyles.tag} color="#131f28">
            {data.active ? (
              <span
                style={{
                  ...CustomStyles.activeDot,
                  ...CustomStyles.activeDotGreen,
                }}
              />
            ) : (
              <span
                style={{
                  ...CustomStyles.activeDot,
                  ...CustomStyles.activeDotRed,
                }}
              />
            )}
            <span style={{ color: data.active ? 'green' : 'red' }}>
              {data.active ? 'Active' : 'Inactive'}
            </span>
          </Tag>
          <div style={CustomStyles.inactiveDot} />
        </div>
      ),
      sorter: false,
      filterDropdown: ({ setSelectedKeys, confirm }) => {
        const handleConfirm = () => {
          const selectedKeys = ['active'];
          setSelectedKeys(selectedKeys);
          confirm();
          handleChangeFilter(statusFilterAction, 'active')
        };
        return (
          <div style={CustomStyles.container}>
            <div style={{ marginBottom: 5, marginLeft: 38 }}>
              <Switch
                style={CustomStyles.filterSwitch}
                checked={statusFilterAction}
                checkedChildren="Active"
                unCheckedChildren="All"
                onChange={(e) => setStatusFilterAction(e)}
              />
            </div>
            <div style={{ marginTop: 15 }}>
              <button
                type="button"
                onClick={handleConfirm}
                onPressEnter={handleConfirm}
                style={CustomStyles.applyButton}
              >
                Apply
              </button>
            </div>
          </div>
        );
      },
    },
    {
      title: " First Name",
      dataIndex: "firstName",
      render: (_, data) => <a>{data?.firstName }</a>,
      sorter: true,
      width: 100, // Set custom width for this column
    },
    {
      title: "Email Address",
      dataIndex: "email",
      render: (text) => <a>{text}</a>,
      sorter: true,
      width: 350, // Set custom width for this column
    },
    {
      title: "Location",
      dataIndex: ``,
      render: (_, data) => {
        const loc = location.find((e) => String(e?._id) === data.locationId);
        return (
          <span>
            {loc?.name}, {loc?.state}
          </span>
        )
      },

      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        const handleConfirm = () => {
          setSelectedFilters(selectedKeys);
          confirm();
          handleChangeFilter(selectedLocationSearch, 'location');
        };

        const handleReload = () => {
          setSelectedKeys([]);
          setSortDirection(null);
          setReloadClicked(true);
          setSelectedLocationSearch([]);
          handleChangeFilter([], 'location')
        };

        return (
          <div style={CustomStyles.container}>
            {/* Sort options */}
            <div style={CustomStyles.sortOptions}>
              <div>
                <Radio
                  onChange={() => handleOnChange('location',1)}
                  checked={sortBy.name === "location" && sortBy.dir === 1}
                  style={CustomStyles.radio}
                >
                  Sort A to Z
                </Radio>
              </div>
              <div>
                <Radio
                  onChange={() => handleOnChange('location', -1)}
                  checked={sortBy.name === "location" && sortBy.dir === -1}
                  style={CustomStyles.radio}
                >
                  Sort Z to A
                </Radio>
              </div>
            </div>

            <div style={{ marginBottom: 15, marginTop: 15 }}>
              <Input
                placeholder="Search ..."
                value={selectedKeys[0]}
                onChange={(e) => handleFilterLocationSearch(e)}
                style={CustomStyles.searchInput}
              />
            </div>

            <div style={CustomStyles.checkboxOptions}>
              {/* Checkbox options */}
              {filteredLocationSearch?.map((option) => (
                <div key={option.value} style={CustomStyles.checkboxContainer}>
                  <span style={CustomStyles.checkboxText}>
                    {option.name}, {option.state}
                  </span>
                  <Checkbox
                    checked={selectedLocationSearch.includes(option._id)}
                    onChange={(e) => handleCheckboxChangeLocation(option._id)}
                    style={CustomStyles.radio}
                  />
                </div>
              ))}
            </div>

            <div style={{ marginTop: 20 }}>
              <button
                type="button"
                onClick={handleConfirm}
                onPressEnter={handleConfirm}
                style={CustomStyles.applyButton}
              >
                Apply
              </button>
            </div>

            <div style={CustomStyles.reloadButtonContainer}>
              <div style={CustomStyles.reloadButton} onClick={handleReload}>
                <ReloadOutlined style={CustomStyles.reloadIcon} />
              </div>
            </div>
          </div>
        );
      },

      onFilter: (value, record) => handleFilterLocation(value, record),
    },
    {
      title: "Access Level",
      dataIndex: "",
      render: (_, data) => {
        const role = roles.find((e) => String(e._id) === data.roleId)
        return (
          <span>{role?.role}</span>
        )
      },

      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        const handleConfirm = () => {
          setSelectedFilters(selectedKeys);
          confirm();
          handleChangeFilter(selectedRoleSearch, 'role');
        };

        const handleReload = () => {
          setSelectedKeys([]);
          setSortDirection(null);
          setReloadClicked(true);
          setSelectedRoleSearch([]);
          handleChangeFilter([], 'role');
        };

        return (
          <div style={CustomStyles.container}>
            {/* Sort options */}
            <div style={CustomStyles.sortOptions}>
              <div>
                <Radio
                 onChange={() => handleOnChange('role',1)}
                 checked={sortBy.name === "role" && sortBy.dir === 1}
                  style={CustomStyles.radio}
                >
                  Sort A to Z
                </Radio>
              </div>
              <div>
                <Radio
                  onChange={() => handleOnChange('role',-1)}
                  checked={sortBy.name === "role" && sortBy.dir === -1}
                  style={CustomStyles.radio}
                >
                  Sort Z to A
                </Radio>
              </div>
            </div>

            <div style={{ marginBottom: 15, marginTop: 15 }}>
              <Input
                placeholder="Search ..."
                value={selectedKeys[0]}
                onChange={(e) => handleFilterRoleSearch(e)}
                style={CustomStyles.searchInput}
              />
            </div>

            <div style={CustomStyles.checkboxOptions}>
              {/* Checkbox options */}
              {filteredRoleSearch?.map((option) => (
                <div key={option.value} style={CustomStyles.checkboxContainer}>
                  <span style={CustomStyles.checkboxText}>
                    {option.role}
                  </span>
                  <Checkbox
                    checked={selectedRoleSearch.includes(option._id)}
                    onChange={(e) => handleCheckboxChangeRoles(option._id)}
                    style={CustomStyles.radio}
                  />
                </div>
              ))}
            </div>

            <div style={{ marginTop: 20 }}>
              <button
                type="button"
                onClick={handleConfirm}
                onPressEnter={handleConfirm}
                style={CustomStyles.applyButton}
              >
                Apply
              </button>
            </div>

            <div style={CustomStyles.reloadButtonContainer}>
              <div style={CustomStyles.reloadButton} onClick={handleReload}>
                <ReloadOutlined style={CustomStyles.reloadIcon} />
              </div>
            </div>
          </div>
        );
      },

      onFilter: (value, record) => handleFilterLocation(value, record),
    },
    {
      title: "Login as User",
      render: (_, item) =>
        getUserPermissions("login-user-action") && (
          <Button
            title="Login"
            className="login-button"
            onClick={() => handleLoginAsUser(item?.email, item?.password)}
          />
        ),
    },
    {
      title: "Action",
      render: (_, item) =>
        getUserPermissions("edit-user-action") && (
          <a>
            <FiEye
              onClick={() => {
                history.push(`/user/${item._id}`);
              }}
            />
          </a>
        ),
    },
  ];

  useImperativeHandle(ref, () => ({
    resetRoleAndLocation() {
      setSortDirection(null);
      setSelectedLocationSearch([]);
      setSortDirection(null);
      setSelectedLocationSearch([]);
    },
    setActive(value) {
      setStatusFilterAction(value)
    },
    setLocationFilter(value) {
      setSelectedLocationSearch(value);
    },
    setRoleFilter(value) {
      setSelectedRoleSearch(value);
    }
  }));
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const entries = Object.fromEntries(urlParams);
    setOffset(pagination?.offset || entries?.offset);
    setLimit(pagination?.limit || entries?.limit);
    setFilteredData(data);
  }, [data])
  useEffect(() => {
    setFilteredLocationSearch(location || []);
  }, [location])
  useEffect(() => {
    setFilteredRoleSearch(roles || []);
  }, [roles])
  useEffect(() => {
    setFilteredLocationSearch(location || []);
    setFilteredRoleSearch(roles || []);
  }, [])

  return (
    <Wrapper>
      <Table
        pagination={false}
        rowKey={record => record._id}
        columns={columns}
        dataSource={filteredData.length > 0 ? filteredData : data}
        onChange={handleSortOnChange}
        loading={isLoading}
        scroll={{ x: 'max-content' }} // Enable horizontal scrolling
      />
      {data && data?.length ? (
        <div className="pagination-table">
          <Pagination showSizeChanger onShowSizeChange={onShowSizeChange} onChange={handleChangePagination} defaultCurrent={offset} defaultPageSize={limit} total={pagination.total} />
        </div>
      ) : null}
    </Wrapper>
  );
});

export default UsersTable;
